import { useUILayerStore } from '@_shared/stores/useUILayerStore';
import { FolderNameUpdatePopup } from '../ui';

interface IProps {
	folderId: string;
	initialFolderName: string;
}

export function useFolderNameUpdatePopup({ folderId, initialFolderName }: IProps) {
	const { pushLayer } = useUILayerStore();

	function openFolderNameUpdatePopup() {
		pushLayer(
			'popup',
			<FolderNameUpdatePopup folderId={folderId} initialFolderName={initialFolderName} />,
		);
	}

	return {
		openFolderNameUpdatePopup,
	};
}
